import React from 'react';

import style from './index.scss';

import ExplainabilityTooltip from './ExplainabilityTooltip';

import { transformFeatureValue } from '../../../../util/featureTransformation';
import { fetchFeatureToolTipCaption } from '../../../../util/featureDescription';

const FeatureItems = ({ hits, cluster, clusterIndex, isCollapsed }) => {
  if (!isCollapsed) {
    if (cluster) {
      const { features = [] } = cluster;

      if (Array.isArray(features) && features.length > 0) {
        // loop each feature

        return features.map((currentFeature, featureIdx) => {
          // then loop hits and dump their feature value in an array
          const hitsFeatureValues = [];
          if (Array.isArray(hits) && hits.length > 0) {
            hits.forEach((currentHit) => {
              const { clusters = [] } = currentHit;

              // get cluster based on cluster index passed
              const currentHitCluster = clusters[clusterIndex];
              if (currentHitCluster) {
                if (
                  Array.isArray(currentHitCluster.features) &&
                  currentHitCluster.features.length > 0
                ) {
                  // get feature based on feature index
                  const currentHitFeature =
                    currentHitCluster.features[featureIdx];

                  if (currentHitFeature) {
                    const { featureContribution = 0 } = currentHitFeature;
                    const formattedFeatureValue =
                      transformFeatureValue(currentHitFeature);
                    let fontColorCriteria = '#556069';
                    if (!Number.isNaN(featureContribution)) {
                      if (formattedFeatureValue === 'Match') {
                        fontColorCriteria = '#2ecc71';
                      }

                      if (
                        formattedFeatureValue === 'Insufficient Information'
                      ) {
                        fontColorCriteria = '#f1c40f';
                      }

                      if (formattedFeatureValue === 'Mismatch') {
                        fontColorCriteria = '#e74c3c';
                      }
                    }

                    hitsFeatureValues.push(
                      <td>
                        <div className="row">
                          <div className="col-sm-7">
                            <p className={style.featureValue}>
                              {formattedFeatureValue}
                            </p>
                          </div>
                          <div className="col-sm-5">
                            <p
                              style={{
                                float: 'right',
                                color: fontColorCriteria,
                                minWidth: 70,
                                textAlign: 'right',
                                margin: '0px!important'
                              }}>
                              {!Number.isNaN(featureContribution)
                                ? `${Number(featureContribution * 100).toFixed(
                                    2
                                  )}%`
                                : `${featureContribution}%`}
                            </p>
                          </div>
                        </div>
                      </td>
                    );
                  }
                }
              }
            });
          }

          // This is to indicate whether current feature is Inferred Minimum Age
          let isInferredMinimumAge = false;
          if (
            currentFeature?.name &&
            currentFeature.name.toUpperCase().replace(/\s+/g, '_') ===
              'INFERRED_MINIMUM_AGE'
          ) {
            isInferredMinimumAge = true;
          }

          // tooltip renderiing
          const tooltipContent = fetchFeatureToolTipCaption(currentFeature);
          let tooltipComponent = null;
          let tooltipIcon = null;

          if (tooltipContent) {
            tooltipComponent = (
              <ExplainabilityTooltip
                className={style.tooltipStyles}
                placement="bottom"
                target={`clusterId-${cluster.id}-feature-${featureIdx}`}>
                <div className={style.toolTipItem}>{tooltipContent}</div>
              </ExplainabilityTooltip>
            );

            tooltipIcon = (
              <span
                id={`clusterId-${cluster.id}-feature-${featureIdx}`}
                className={style.infoTooltipIcon}>
                <i className="fa fa-info" />
              </span>
            );
          }

          return (
            <tr>
              <td colSpan={2}>
                {isInferredMinimumAge ? (
                  <b>
                    <i>{currentFeature.name}</i>
                  </b>
                ) : (
                  currentFeature.name
                )}
                {tooltipIcon}
                {tooltipComponent}
              </td>
              {hitsFeatureValues}
            </tr>
          );
        });
      }
    }
  }

  return [];
};

const ClusterFeatures = ({ data, collapsedIndex, onToggleCollapseState }) => {
  if (data) {
    const { hits = [] } = data;

    if (Array.isArray(hits) && hits.length > 0) {
      // get first hit's cluster as basis for labels
      const clusterFeaturesLabelList = hits[0].clusters;

      if (
        Array.isArray(clusterFeaturesLabelList) &&
        clusterFeaturesLabelList.length > 0
      ) {
        return clusterFeaturesLabelList.map(
          (currentCluster, currentClusterIndex) => {
            let collapsedClass = 'fa fa-angle-down';
            const clusterContributionItems = [];

            // loop for cluster contribution
            hits.forEach((currentHit) => {
              const { clusters = [] } = currentHit;

              if (Array.isArray(clusters) && clusters.length > 0) {
                const currentHitCluster = clusters[currentClusterIndex];

                clusterContributionItems.push(
                  <td key={currentHitCluster.name}>
                    {!Number.isNaN(currentHitCluster.clusterContribution)
                      ? `${Number(
                          currentHitCluster.clusterContribution * 100
                        ).toFixed(2)}%`
                      : ''}
                  </td>
                );
              }
            });

            // if not collapsed, render feature items
            if (collapsedIndex === currentClusterIndex) {
              collapsedClass = 'fa fa-angle-up';
            }

            return [
              <tr className={style.collapsibleRow} key={currentCluster.name}>
                <td colSpan={2}>
                  <p>
                    <i
                      onClick={() => onToggleCollapseState(currentClusterIndex)}
                      className={collapsedClass}
                    />
                    <b>{currentCluster.name}</b>
                  </p>
                </td>
                {clusterContributionItems}
              </tr>,
              <FeatureItems
                hits={hits}
                cluster={currentCluster}
                clusterIndex={currentClusterIndex}
                isCollapsed={collapsedIndex !== currentClusterIndex}
              />
            ];
          }
        );
      }

      return null;
    }

    return null;
  }

  return null;
};

export default ClusterFeatures;
